/** POST `body` as JSON; a network error is retried `retries` times with the exact same payload (request IDs stay stable). */
export async function postJsonResponse(url: string, body: unknown, opts: { retries?: number } = {}): Promise<Response> {
  const payload = JSON.stringify(body);
  for (let attempt = 0; ; attempt++) {
    try { return await fetch(url, { method: "POST", headers: { "content-type": "application/json" }, body: payload }); }
    catch (error) { if (attempt >= (opts.retries ?? 0)) throw error; }
  }
}
/** Like `postJsonResponse`, but throws on an error status and returns the parsed reply. */
export async function postJson<T = any>(url: string, body: unknown, opts: { retries?: number } = {}): Promise<T> {
  const response = await postJsonResponse(url, body, opts);
  if (!response.ok) throw new Error(String(response.status));
  return await response.json() as T;
}
